// extracted by mini-css-extract-plugin
module.exports = {"instituteContainer":"qRBcB","svg":"fWUYP","figureWave":"jPGZw","figureGroup":"WBkts","figureCircle":"_0wavn","figureSquare":"G6pHC"};